import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatPaginator, MatSelectChange, MatTableDataSource, PageEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions';
import { STATUS } from 'src/app/shared/helpers/status';
import { environment } from 'src/environments/environment';
import { ViewActivationImageComponent } from '../../dashboard/view-activation-image/view-activation-image.component';
import { AddActivationImageComponent } from '../../dashboard/add-activation-image/add-activation-image.component';
import { JobPipe } from 'src/@core/pipes/data/job.pipe';
import { EnterpriseAdminService } from '../enterprise-admin.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { API_ACCOUNT_CREDIT, API_GET_SUMMARY, API_WORK_ORDER_EXPORT, API_WORK_ORDER_GOOGLE_AUTHORIZE, API_WORK_ORDER_GOOGLE_CALLBACK } from 'src/@core/services/util/api.endpoints';
import moment from 'moment';
import { Search } from 'src/@core/interfaces/search';
import { DatePipe } from '@angular/common';
import { element } from 'protractor';
import { LocalStorageService } from 'src/@core/services/local-storage.service';

@Component({
  selector: 'hour4u-admin-work-order-table',
  templateUrl: './work-order-table.component.html',
  styleUrls: ['./work-order-table.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
})
export class WorkOrderTableComponent implements OnInit {
  @Input() showFilter: boolean = true;
  @Input() showOverview: boolean = true;
  @Input() showTable: boolean = true;
  @ViewChild('workOrderTable', { static: true }) workOrderTable: WorkOrderTableComponent;

  roles = roles;
  entityTypes = entityTypes;
  permissions = permissions;
  workOrderData: any;
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;
  pageSizeOptions: number[] = [10, 20, 50, 100, 500];
  profile = this.appService.getCurrentAccount();
  workOrderDataSource: MatTableDataSource<any>;
  dateFormControl = new FormControl();
  // workOrderFilterData: FormGroup;
  // selectedCityOptions: string[] = [];
  // selectedAgencyOptions: string[] = [];
  // selectedOptions: string[] = [];
  selectedOptions: string = '';
  selectedCityOptions: string = '';
  selectedAgencyOptions: string = '';
  s3Url = environment.image_url;
  customOptions: any;
  displayedBanners: { [bannerId: string]: boolean };
  status = STATUS;
  currentUserRole: any = null;
  apiCallCompleted: boolean = false;
  credits: any = null;
  workOrderSummary: any;
  selectedStatus: string = '';
  selectedCity: string = '';
  selectedAgency: string = '';
  columns = [
    { columnDef: 'name', visible: true, label: 'Name' },
    { columnDef: 'status', visible: true, label: 'Status' },
    { columnDef: 'city', visible: true, label: 'City' },
    { columnDef: 'agency', visible: true, label: 'Agency' },
    { columnDef: 'vendor', visible: true, label: 'Vendor' },
    { columnDef: 'client', visible: true, label: 'Client' },
    { columnDef: 'fulfilment', visible: true, label: 'Fulfilment' },
    { columnDef: 'totalTasks', visible: true, label: 'Total Tasks' },
    { columnDef: 'approved', visible: true, label: 'Approved' },
    { columnDef: 'activationImage', visible: true, label: 'Activation Image' },
    { columnDef: 'activationApproval', visible: true, label: 'Activation Approval' },
  ];
  displayedColumns = [...this.columns.map(x => x.columnDef), 'actions'];

  multiselectOptions = [
    // { value: 'Approved', label: 'Approved' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Active', label: 'Active' },
    { value: 'Rejected', label: 'Rejected' }
  ];
  cityMultiselectOptions = [
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Gurugram', label: 'Gurugram' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Bangalore', label: 'Bangalore' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Dehradun', label: 'Dehradun' },

  ];

  agencyMultiselectOptions = [];
  selected: any = "";

  ranges: any = {
    'Today': [moment()],
    'Yesterday': [moment().subtract(1, "days")],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  }
  isLoading: boolean = false;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  isExporting: boolean = false;
  isExportingToSheets: boolean = false;
  prevUrl: String;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  spreadsheetUrl: string;
  jobsLength: number = 0;
  filterByName: string = '';

  constructor(
    public appService: AppService,
    private dialog: MatDialog,
    public jobService: JobService,
    public router: Router,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private jobPipe: JobPipe,
    public enterpriseAdminService: EnterpriseAdminService,
    private notify: NotificationService,
    private http: HttpClient,
    private datePipe: DatePipe,
    private _localStorageService: LocalStorageService,
    private route: ActivatedRoute,
  ) {
    if (this.router && this.router.getCurrentNavigation() && this.router.getCurrentNavigation().previousNavigation) {
      this.prevUrl = this.router.getCurrentNavigation().previousNavigation.finalUrl.toString();
    }
  }

  ngOnInit() {
    this.getSheetCodeFromUrl();
  }

  // get current user role
  getCurrentRole() {
    this.appService.currentUser.subscribe(currentUser => {
      if (currentUser && currentUser.roles && currentUser.roles.length) {
        currentUser.roles.forEach(ele => {
          this.currentUserRole = ele;
          this.getCredits();
        })
      }
    })
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void {

    this.workOrderDataSource = new MatTableDataSource(this.workOrderData);
    this.getCurrentRole();
    this.getWorkOrderSummary();
    this.fetchDashboardData();
    this.getAllAgencies();

    // // Filter out 'agency' column
    // Inside the if-else block where you apply column filtering
    if (this.profile.entity.entityType === 'AGENCY') {
      this.columns = this.columns.filter(column => column.columnDef !== 'agency');
      this.displayedColumns = this.columns.map(x => x.columnDef);
    } else if (this.profile.entity.entityType === 'ENTERPRISE' || this.profile.entity.entityType === 'VENDOR') {
      this.columns = this.columns.filter(column => column.columnDef !== 'client');
      this.displayedColumns = this.columns.map(x => x.columnDef);

      this.columns = this.columns.filter(column => column.columnDef !== 'vendor');
      this.displayedColumns = this.columns.map(x => x.columnDef);
    }
    // Add the "actions" column to the displayedColumns array if it's not already included
    if (!this.displayedColumns.includes('actions')) {
      this.displayedColumns.push('actions');
    }

    this.jobService!.searchAndSort(
      this.pageIndex,
      this.pageSize,
      "createdOn",
      "desc",
      []
    ).subscribe((data: any) => {
      if (data) {
        this.jobsLength = data.totalElements;
      }
    })

  }

  onDateRangeChanged(event: any) {
    // console.log("Callllllllllllllllllllllll", event)
    if (event && event.startDate && event.endDate) {
      this.selected = event;
      this.fetchDashboardData();
      this.getWorkOrderSummary();
    }
  }

  // // Method to load more data when user scrolls to the bottom
  // loadMoreData() {
  //   console.log('Scrolled to bottom, loading more data...');
  //   this.pageIndex++;
  //   this.fetchDashboardData();
  // }

  fetchDashboardData() {
    this.isLoading = true;
    let params = new HttpParams();

    // Ensure pageIndex and pageSize are defined with default values
    if (this.pageIndex === undefined || this.pageIndex === null) {
      this.pageIndex = 0;  // default to first page
    }
    if (this.pageSize === undefined || this.pageSize === null) {
      this.pageSize = 10;  // default page size
    }

    // Check for stored page index in specific conditions
    if (this.prevUrl && (this.prevUrl.includes('enterprise-admin/view-work-order')
      || this.prevUrl.includes('employment/job-applications')
      || this.prevUrl.includes('employment/active'))) {
      let storedPageIndex = this._localStorageService.getJobListPage();
      if (storedPageIndex !== undefined && storedPageIndex !== null) {
        this.pageIndex = storedPageIndex;
      }
    }

    // Set pagination params
    params = params
      .set('page', this.pageIndex.toString())
      .set('size', this.pageSize.toString());

    // Set filters (status, city, agency, date range, etc.)
    if (this.selectedOptions) {
      if (Array.isArray(this.selectedOptions)) {
        this.selectedOptions.forEach(status => {
          params = params.append('status', status);
        });
      } else {
        params = params.set('status', this.selectedOptions);
      }
    }
    if (this.selectedCityOptions) {
      if (Array.isArray(this.selectedCityOptions)) {
        this.selectedCityOptions.forEach(city => {
          params = params.append('city', city);
        });
      } else {
        params = params.set('city', this.selectedCityOptions);
      }
    }
    if (this.selectedAgencyOptions) {
      if (Array.isArray(this.selectedAgencyOptions)) {
        this.selectedAgencyOptions.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', this.selectedAgencyOptions);
      }
    }

    if (this.selected && this.selected.startDate && this.selected.endDate) {
      params = params
        .set('startDate', moment(this.selected.startDate).format("YYYY-MM-DD"))
        .set('endDate', this.selected.endDate.toISOString().split("T")[0]);
    }

    if (this.filterByName) {
      params = params.set('workOrderTitle', this.filterByName);
    }

    // Update paginator state after fetching data
    setTimeout(() => {
      if (this.paginator) {
        this.paginator.pageIndex = this.pageIndex;
        this.paginator.pageSize = this.pageSize;
      }
    }, 2000);

    // API call to fetch data
    this.jobService.searchAndSortDashboardData(params)
      .subscribe(
        (response) => {
          this.workOrderData = response.content;

          //Uncomment the below code to enable Concatenation of data in table
          // Check if it's an infinite scroll request (appending data) or a fresh load (replacing data)
          // if (this.pageIndex === 0) {
          //   this.workOrderData = response.content; // Replace the data if it's the first page
          // } else {
          //   this.workOrderData = [...this.workOrderData, ...response.content]; // Concatenate new data
          // }

          this.workOrderData.forEach((workOrder) => {
            if (workOrder.activationProof === null) {
              workOrder.activationProof = { status: 'PENDING' };
            }
          });

          this.resultsLength = response.totalElements;
          this.workOrderDataSource = new MatTableDataSource(this.workOrderData);

          this.apiCallCompleted = true;
          this.isLoading = false;
          this._localStorageService.setJobListPage(this.pageIndex);
        },
        (error) => {
          this.isLoading = false;
          console.error('Failed to fetch dashboard data:', error);
        }
      );
  }

  clearDateRange(event) {
    event.stopPropagation();
    this.selected = null;
    this.fetchDashboardData();
  }
  getAllAgencies() {
    const searchParams = [];
    const entityId = this.profile.entity.id;

    if (entityId) {
      // if (this.searchField) {
      //   this.searchParams.push(new Search('query', this.searchField));
      // }
      searchParams.push(new Search('entityType', 'AGENCY'));
      // Call the method from job service to fetch agencies
      this.jobService.searchAndSortAgencies(entityId, this.pageIndex, 1000, 'createdOn', null, searchParams)
        .subscribe(data => {
          // Store the fetched agency data in the agencyMultiselectOptions variable
          this.agencyMultiselectOptions = data.content.map(agency => ({
            value: agency.id,
            label: agency.entityMeta.name
          }));

        }, error => {
          //this.notify.showMessage('Something went wrong!', 2000);
        });
    } else {
      console.warn('Entity ID is not available. Unable to fetch agencies.');
    }
  }

  searchAgencyByInput(event) {
    this.agencyMultiselectOptions = this.agencyMultiselectOptions.filter(label =>
      label.label.toLowerCase().indexOf(event.target.value.toLowerCase()) != -1);
  }

  clearCitySelection(eventData: Event): void {
    this.selectedCityOptions = '';
    this.getWorkOrderSummary();
    this.fetchDashboardData();
    eventData.stopPropagation();
  }

  clearAgencySelection(eventData: Event): void {
    this.selectedAgencyOptions = '';
    this.getWorkOrderSummary();

    this.fetchDashboardData();
    eventData.stopPropagation();
  }
  clearStatusSelection(eventData: Event) {
    this.selectedOptions = '';
    this.getWorkOrderSummary();

    this.fetchDashboardData();
    eventData.stopPropagation();
  }


  onFilterChange(): void {
    this.paginator.pageIndex = this.pageIndex;
    this.paginator.pageSize = this.pageSize;
    this.getWorkOrderSummary();
    this.fetchDashboardData();
  }

  getTotalJobApplicants(items: any[], gender: string) {
    let totalApplicants = 0;

    if (items) {
      items.forEach(item => {
        totalApplicants += item[`${gender}JobApplicants`] || 0;
      });
    }

    return totalApplicants;
  }

  getTotalTasks(items: any[]): number {
    let totalTasks = 0;

    if (items) {
      items.forEach(item => {
        if (item.totalTasks) {
          totalTasks += item.totalTasks;
        }
      });
    }
    return totalTasks;
  }

  getApprovedTasks(items: any[]): number {
    let approvedTasks = 0;

    if (items) {
      items.forEach(item => {
        if (item.approvedTasks) {
          approvedTasks += item.approvedTasks;
        }
      });
    }
    return approvedTasks;
  }


  getTotalFulfilment(items: any[]): number {
    let totalQuantity = 0;

    if (items) {
      items.forEach(item => {
        if (item.billingItems && item.billingItems.length > 0) {
          // Only calculate the quantity of the item at index 0 i.e selected JobType
          totalQuantity += item.billingItems[0].quantity || 0;
        }
      });
    }

    return totalQuantity;
  }



  getEachFulfilment(element: any, billingItems: any[]): number {
    if (element.numberOfVariableFulfilment) {
      return element.numberOfVariableFulfilment;
    } else {
      if (billingItems && billingItems.length > 0) {
        // Only calculate the quantity of the item at index 0 i.e selected JobType
        return billingItems[0].quantity || 0;
      }
    }
    return 0;
  }
  onPageChange(event: PageEvent): void {
    console.log(event.pageIndex, event.pageSize);
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this._localStorageService.setJobListPage(this.pageIndex);
    this.fetchDashboardData();
  }

  onWorkOrderClick(element: any): void {
    const workOrderId = element.id;
    if (element.status == 'Pending') {
      this.router.navigateByUrl('/enterprise-admin/view-work-order/' + workOrderId);
    } else {
      this.router.navigateByUrl('/employment/job-applications/all/' + workOrderId);
    }
  }

  filter = {
    status: '',
    city: ''
  };


  // Filter date picker
  // setNextDate(): void {
  //   const currentDate = this.workOrderFilterData.get('dateFrom').value || new Date();
  //   const nextDate = new Date(currentDate);
  //   nextDate.setDate(currentDate.getDate() + 1);
  //   this.workOrderFilterData.get('dateFrom').setValue(nextDate);
  // }
  // setPrevDate(): void {
  //   const currentDate = this.workOrderFilterData.get('dateFrom').value || new Date();
  //   const previousDate = new Date(currentDate);
  //   previousDate.setDate(currentDate.getDate() - 1);
  //   this.workOrderFilterData.get('dateFrom').setValue(previousDate);
  // }

  generateSelectedLabel(): string {
    if (this.selectedOptions.length === 0) {
      return 'Select Status';
    } else if (this.selectedOptions.length === 1) {
      return this.selectedOptions[0];
    } else {
      return `${this.selectedOptions[0]} + ${this.selectedOptions.length - 1}`;
    }
  }
  stopPropagation(event: Event) {
    event.stopPropagation();
  }


  handleUploadClick(event: Event, element: any) {
    event.stopPropagation();
    // Open the AddActivationImageComponent in a dialog
    const dialogRef = this.dialog.open(AddActivationImageComponent, {
      width: '500px',
      data: {
        workOrder: element,
        dashboardComponent: this
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed with result:', result);
    });
  }

  viewActivationImage(event: Event, element: any) {
    event.stopPropagation();

    // Check if imageUrl is available
    if (element.activationProof && element.activationProof.imageUrl) {
      const imageUrl = this.s3Url + element.activationProof.imageUrl;

      // Open the image in a modal dialog
      const dialogRef = this.dialog.open(ViewActivationImageComponent, {
        panelClass: 'add-edit-user-dialog',
        data: {
          imageUrl: imageUrl,
          workOrder: element,
          dashboardComponent: this
        },
      });

      // Prevent the default action (download) of the original click event
      event.preventDefault();
    } else {
      console.error('Image URL not available.');
    }
  }


  // Change application status
  changeApplicationStatus(status, job) {
    // console.log(status, job)
    let obj = {
      "updatedStatus": status,
      "assignerId": job.id,
      "fulfillerType": this.currentUserRole
    }
    // console.log(obj)
    if (status == 'ACCEPTED') {
      // const dialogRef = this.dialog.open(TermsConditionsComponent, {
      //   data: obj,
      //   panelClass: 'terms-dialog',
      // });
      // dialogRef.afterClosed().subscribe(result => {
      //   if (result) {
      //     this.getShiftsList();
      //   }
      // });
      this.approveWorkOrder(job);
    } else if (status = 'AGENCY_APPROVED') {
      this.approveWorkOrderByAgency(job)
    } else if (status = 'AGECNY_REJECTED') {
      this.rejectWorkOrderByAgency(job);
    }
    else {
      // alert("will comming soon...")
      this.rejectWorkOrder(job);
    }
  }

  // approve work order
  approveWorkOrder(job) {
    this.enterpriseAdminService.approveWorkOrder(job.id, null).subscribe((response: any) => {
      this.notify.showMessage('Work order approved successfully!', 3000)
      this.ngAfterViewInit();
    }, (err => {
      this.notify.showMessage('Work order approved failed!', 3000)
    }))
  }

  // approve work order by agency
  approveWorkOrderByAgency(job) {
    this.enterpriseAdminService.approveWorkOrderByAgency(job.id, null).subscribe((response: any) => {
      this.notify.showMessage('Work order approved successfully!', 3000)
      this.ngAfterViewInit();
    }, (err => {
      this.notify.showMessage('Work order approved failed!', 3000)
    }))
  }

  // reject work order by agency
  rejectWorkOrderByAgency(job) {
    this.enterpriseAdminService.rejectWorkOrderByAgency(job.id, null).subscribe((response: any) => {
      this.notify.showMessage('Work order rejected !', 3000)
      this.ngAfterViewInit();
    }, (err => {
      this.notify.showMessage('Work order rejection failed!', 3000)
    }))
  }

  // reject work order
  rejectWorkOrder(job) {
    this.enterpriseAdminService.rejectWorkOrder(job.id, null).subscribe((response: any) => {
      this.notify.showMessage('Work order rejected successfully!', 3000)
      this.ngAfterViewInit();
    }, (err => {
      this.notify.showMessage('Work order rejected failed!', 3000)
    }))
  }



  exportData(selectedCity: string, selectedStatus: string, selectedAgency: string) {
    this.isExporting = true;
    let params = new HttpParams();

    // Add selected filters to params
    if (selectedCity) {
      if (Array.isArray(selectedCity)) {
        selectedCity.forEach(city => {
          params = params.append('city', city);
        });
      } else {
        params = params.set('city', selectedCity);
      }
    }
    if (selectedStatus) {
      if (Array.isArray(selectedStatus)) {
        selectedStatus.forEach(status => {
          params = params.append('status', status);
        });
      } else {
        params = params.set('status', selectedStatus);
      }
    }
    if (selectedAgency) {
      if (Array.isArray(selectedAgency)) {
        selectedAgency.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', selectedAgency);
      }
    }

    // Add startDate and endDate if available
    if (this.selected && this.selected.startDate && this.selected.endDate) {
      params = params.set('startDate', this.selected.startDate.format('YYYY-MM-DD'));
      params = params.set('endDate', this.selected.endDate.format('YYYY-MM-DD'));
    }

    this.http.get(API_WORK_ORDER_EXPORT, { params, responseType: 'blob', observe: 'response' })
      .subscribe((response: HttpResponse<Blob>) => {
        this.isLoading = false;
        this.isExporting = false;
        // Handle the API response, which is a file to download
        const blob = new Blob([response.body!], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);

        // Create a link element and trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = 'workorder-data.xlsx'; // specify the desired filename here
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }, (err => {
        this.isLoading = false;
        this.isExporting = false;
      }));
  }




  viewTasks(event: Event, job) {
    event.stopPropagation();

    const url = this.router.serializeUrl(this.router.createUrlTree(['/employment/active/workproof/', job.id, {
      date: job.dates[0].date,
      for: 'all',
      view: 'table'
    }]));

    window.open(url, '_blank');
  }

  // get Credits
  getCredits() {
    // console.log(this.profile)
    if (this.profile.entity.entityType === 'ENTERPRISE' || this.profile.entity.entityType === 'AGENCY') {
      this.http.get(API_ACCOUNT_CREDIT + '/' + this.profile.entity.id).subscribe(
        (response: any) => {
          // console.log(response)
          if (response) {
            response.remainCredits = response.taskCredits - response.usedCredits;
            this.credits = response;
          }
        })
    }
  }



  getWorkOrderSummary(): void {
    let params = new HttpParams();

    // Add selected filters to params
    if (this.selectedCityOptions) {
      if (Array.isArray(this.selectedCityOptions)) {
        this.selectedCityOptions.forEach(city => {
          params = params.append('city', city);
        });
      } else {
        params = params.set('city', this.selectedCityOptions);
      }
    }
    if (this.selectedOptions) {
      if (Array.isArray(this.selectedOptions)) {
        this.selectedOptions.forEach(status => {
          params = params.append('status', status);
        });
      } else {
        params = params.set('status', this.selectedOptions);
      }
    }
    if (this.selectedAgencyOptions) {
      if (Array.isArray(this.selectedAgencyOptions)) {
        this.selectedAgencyOptions.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', this.selectedAgencyOptions);
      }
    }

    // Add startDate and endDate if available
    if (this.selected && this.selected.startDate && this.selected.endDate) {
      params = params.set('startDate', this.selected.startDate.format('YYYY-MM-DD'));
      params = params.set('endDate', this.selected.endDate.format('YYYY-MM-DD'));
    }

    // Make the HTTP request with the filtered params
    this.http.get(API_GET_SUMMARY, { params }).subscribe(
      result => {
        // console.log('Work Order Summary:', result);
        this.workOrderSummary = result;
      },
      error => console.error('Error fetching work order summary:', error)
    );
  }




  create(): void {
    this.router.navigateByUrl('/enterprise-admin/create-work-order');
  }

  // viewInSheets function with parameters removed
  viewInSheets() {
    this.isExportingToSheets = true;
    this.http.get(API_WORK_ORDER_GOOGLE_AUTHORIZE, { responseType: 'blob', observe: 'response' })
      .subscribe((response: HttpResponse<Blob>) => {
        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result as string;
          try {
            this.isExportingToSheets = false;
            const jsonResponse = JSON.parse(text);
            console.log(jsonResponse.authorizationUrl);
            window.open(jsonResponse.authorizationUrl, '_blank');
          } catch (e) {
            console.error('Error parsing JSON response', e);
            this.isExportingToSheets = false;
          }
        };
        reader.onerror = (e) => {
          console.error('Error reading Blob', e);
          this.isExportingToSheets = false;
        };
        reader.readAsText(response.body);
      });
  }

  // getSheetCodeFromUrl function unchanged
  getSheetCodeFromUrl() {
    this.isExportingToSheets = true;
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const scope = params['scope'];

      if (code && scope) {
        console.log('Code:', code);
        console.log('Scope:', scope);

        // Now you can use these parameters to make an API call
        this.isExportingToSheets = false;
        this.viewGoogleSheets(code, scope);
      } else {
        console.error('Required URL parameters are missing.');
        this.isExportingToSheets = false;
      }
    });
  }

  // viewGoogleSheets function updated to include params
  viewGoogleSheets(code: string, scope: string, selectedCity?: string, selectedStatus?: string, selectedAgency?: string) {
    this.isExportingToSheets = true;
    const apiUrl = API_WORK_ORDER_GOOGLE_CALLBACK;

    // Add selected filters to params
    let params = new HttpParams().set('code', code);

    if (selectedCity) {
      if (Array.isArray(selectedCity)) {
        selectedCity.forEach(city => {
          params = params.append('city', city);
        });
      } else {
        params = params.set('city', selectedCity);
      }
    }
    if (selectedStatus) {
      if (Array.isArray(selectedStatus)) {
        selectedStatus.forEach(status => {
          params = params.append('status', status);
        });
      } else {
        params = params.set('status', selectedStatus);
      }
    }
    if (selectedAgency) {
      if (Array.isArray(selectedAgency)) {
        selectedAgency.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', selectedAgency);
      }
    }

    // Add startDate and endDate if available
    if (this.selected && this.selected.startDate && this.selected.endDate) {
      params = params.set('startDate', this.selected.startDate.format('YYYY-MM-DD'));
      params = params.set('endDate', this.selected.endDate.format('YYYY-MM-DD'));
    }

    this.http.get(apiUrl, { params }).subscribe(
      (response: any) => {
        console.log('API Response:', response);
        this.isExportingToSheets = false;

        const spreadsheetUrl = (response as { spreadsheetUrl: string }).spreadsheetUrl;

        window.location.href = spreadsheetUrl;
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }
  onDataRefresh() {
    console.log('Data refresh event received');
    this.fetchDashboardData();
  }
}